import RootLayout from "../../components/layout/RootLayout";
import GetStarted from "./GetStarted";
import Hero from "./Hero";
import Industries from "./Industries";
import Why from "./Why";

const DataAnnotation = () => {
  return (
    <RootLayout>
      <main>
        <Hero />
        <Why />
        <Industries />
        <GetStarted />
      </main>
    </RootLayout>
  );
};

export default DataAnnotation;
